import { Loader } from '@mantine/core';
import React from 'react';
import SearchIcon from '../../../../../assets/images/module/general/SearchIcon.svg';
import CloseIcon from '@material-ui/icons/Close';

export default function SearchContainer({ className, onChange, value, placeholder, onBlur,onFocus,inputClassName, disabled, loader=false, id }) {
  return (
    <div className={`search-filter ${className}`}>
      <img className="search-icon" src={SearchIcon} alt="search" />
      <input
        className={`search-input ${inputClassName}`}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e)}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        id={id}
      />
      <div className='search-container-right-section'>
        {loader ? 
        <Loader size={'xs'}/> 
        :
        value && 
        <CloseIcon 
        style={{color: '#727293', fontSize: '14px', cursor: 'pointer'}} 
        onClick={()=> {
          if(value){
            onChange({target: { value: '' }});
          } 
        }}/>}
      </div>
    </div>
  );
}
SearchContainer.defaultProps = {
  value: '',
  placeholder: '',
  onChange: () => {},
  disabled: {},
  onFocus:()=>{},
  onBlur:()=>{}
};
